<h1 mat-dialog-title>{{ isEdit ? ('PROJECT.PROJECT_INFO.FILE.TITLE_EDIT' | anessaTranslation: trigger) : ('PROJECT.PROJECT_INFO.FILE.TITLE_ADD' | anessaTranslation: trigger) }}</h1>
<mat-dialog-content>
  <div
    (mouseenter)="showClearName = true"
    (mouseleave)="showClearName = false"
    class="flex-container form-field-container">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{'PROJECT.PROJECT_INFO.FILE.TITLE' | anessaTranslation: trigger}}</mat-label>
      <input
        matInput
        required
        [(ngModel)]="projectFile.name">
    </mat-form-field>
    <p
      *ngIf="projectFile.name && showClearName"
      class="form-field-clear"
      (click)="clearTitle()"
      anessaTranslation="PROJECT.COMMON.CLEAR">
    </p>
  </div>
  <!-- Disable upload button on edit -->
  <div class="upload-button">
    <button
      *ngIf="isEdit"
      mat-raised-button
      (click)="onDownload()"
      anessaTranslation="PROJECT.PROJECT_INFO.FILE.DOWNLOAD">
    </button>
    <button
      *ngIf="!isEdit"
      mat-raised-button
      matTooltip="{{'PROJECT.PROJECT_INFO.FILE.TOOLTIP_UPLOAD' | anessaTranslation: trigger}}"
      onclick="document.getElementById('fileUploadInput').click()"
      anessaTranslation="PROJECT.PROJECT_INFO.FILE.UPLOAD">
    </button>
    <input
      #fileInput
      id="fileUploadInput"
      hidden
      type="file"
      accept=".csv,.xlsx,.pdf"
      (change)="onUpload($event.target)">
  </div>
</mat-dialog-content>
<mat-dialog-actions class="modal-buttons">
  <button
    mat-raised-button
    class="btn-green"
    [disabled]="!projectFile.name || !projectFile.fileId"
    (click)="onSave()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-raised-button
    class="btn-red"
    color="warn"
    (click)="onCancel()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
